import React from 'react';
import { FadeIn } from './FadeIn';
import { Heart, ShoppingBag, Sparkles } from 'lucide-react';
export const Vision = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-220">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-rose/10 rounded-full blur-3xl pointer-events-none" data-id="element-221" />

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-222">
        <FadeIn className="text-center mb-16" data-id="element-223">
          <span className="inline-block text-sm font-semibold tracking-widest uppercase text-accent-rose-deep mb-4" data-id="element-224">
            Imaginate esto
          </span>
          <h2 className="text-4xl md:text-5xl mb-6 leading-tight" data-id="element-225">
            Recibir pedidos desde tu{' '}
            <em className="text-accent-rose-deep" data-id="element-226">celular</em>...
            <br className="hidden md:block" data-id="element-227" />
            <span className="italic" data-id="element-228">mientras construís algo propio.</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-229">
          {[{
          icon: Heart,
          title: 'Lifestyle Femenino',
          desc: 'Tus horarios. Tu ritmo. Un ambiente cozy donde amás trabajar.'
        }, {
          icon: ShoppingBag,
          title: 'Ventas Constantes',
          desc: 'Tu Instagram se vuelve una vitrina que atrae clientas todos los días.'
        }, {
          icon: Sparkles,
          title: 'Marca Premium',
          desc: 'Packaging aesthetic que te permite cobrar precios más altos.'
        }].map((item, i) => <FadeIn key={i} delay={0.1 * (i + 1)} className="glass-panel p-8 rounded-3xl text-center relative group hover:-translate-y-2 transition-transform duration-300" data-id="element-230">
              <div className="w-16 h-16 mx-auto bg-nude rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-231">
                <item.icon className="w-8 h-8 text-accent-rose-deep" data-id="element-232" />
              </div>
              <h3 className="text-xl mb-3 font-bold" data-id="element-233">{item.title}</h3>
              <p className="text-text-brown/80 leading-relaxed" data-id="element-234">{item.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};